// domain/visita.detalle.js  (view model del detalle; funciones puras)
import { resolverProductores } from '../../shared/domain/productor';
import { nombreUsuario } from '../../shared/domain/usuario';
import { idProductor } from './visita';

/** Entidad + catálogos -> view model: productor (con localidad), parcela, usuario e imágenes. */
export const conDetalle = (visita, { productores = [], parcelas = [], usuarios = [] } = {}) => {
  const idCuenta = idProductor(visita);
  const productor = idCuenta ? resolverProductores([idCuenta], productores)[0] : null;
  const parcela = visita.id_parcela === null ? null : parcelas.find(p => p.id === visita.id_parcela);
  return {
    ...visita,
    productor,
    productor_nombre: productor ? productor.nombre : '',
    parcela_nombre: visita.id_parcela === null ? '' : parcela ? parcela.nombre : `Parcela ${visita.id_parcela}`,
    usuario_nombre: nombreUsuario(usuarios, visita.id_user),
    imagenes: visita.media || [],
  };
};
